<template>
  <div>
    <div class="next-back">
      <router-link to="/">Zurück</router-link>
      <router-link to="/getraenke">Weiter</router-link>
    </div>
    <h2>Buffet-Zusammenstellung</h2>
    <div>
      <p v-html="getCategoryDescription('dishes')"></p>
    </div>
    <div v-for="food in foodCategories" :key="food.id">
      <div class="row mt-4">
        <div class="col">
          <h3 v-html="food.name"></h3>
        </div>
      </div>
      <div class="row">
        <div
          class="col-sm-4 mt-2"
          v-for="item in getCateringItemsByCategory(food.name).sort(sortItems)"
          :key="item.id"
        >
          <Input
            :title="item.title"
            :modelName="item.slug.replaceAll('-', '_')"
            :type="item.input_type"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { sortItems } from "@/mixins/sorting-mixins";

import Input from "@/components/Input.vue";

export default {
  name: "FoodView",
  components: {
    Input,
  },
  mixins: [sortItems],
  computed: {
    ...mapGetters([
      "getCateringItemsByCategory",
      "getSubCategoriesByCategoryName",
      "getCategoryDescription",
    ]),
    foodCategories() {
      return this.getSubCategoriesByCategoryName("Speisen").sort((a, b) => {
        if (a.id > b.id) {
          return -1;
        }
        if (a.id < b.id) {
          return 1;
        }
        return 0;
      });
    },
  },
  methods: {
    getItems(category) {
      return this.getCateringItemsByCategory(category);
    },
  },
};
</script>

<style>
</style>